import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import _ from "lodash";

import { Labeled, ButtonComposed, itemList } from "@lifepay/rc-ui-toolkit";

import ProcessingAccess from "components/list-items/ProcessingAccess";

import styles from "./ProcessingRole.m.scss";

import { processingRole } from "model/gql/mutations";

const ProcessingRoleMutations = itemList.MutationFactory([
  processingRole.remove,
]);
@themr("@lifepay/ProcessingRole", styles)
export default class ProcessingRole extends Component {
  static displayName = "ProcessingRole";

  static propTypes = {
    theme: PropTypes.object,
    item: PropTypes.object,
    updateQuery: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      deleteButtonState: "normal",
    };
  }

  render() {
    const { theme, item, updateQuery } = this.props;
    const { deleteButtonState } = this.state;
    return (
      <ProcessingRoleMutations>
        {({ removeProcessingRole }) => (
          <div className={classnames(theme.wrapper)}>
            <div className={classnames(theme.summary)}>
              <Labeled label={"Название роли"} theme={{ label: theme.label }}>
                {item.id}
              </Labeled>
              <Labeled label={"Комментарий"} theme={{ label: theme.label }}>
                {item.comment || "-"}
              </Labeled>
              <ButtonComposed
                state={deleteButtonState}
                disabled={deleteButtonState !== "normal"}
                type={"negative"}
                size={"small"}
                theme={{
                  wrapper: theme.button,
                }}
                onClick={() => {
                  this.setState({
                    deleteButtonState: "loading",
                  });
                  removeProcessingRole
                    .mutate({
                      variables: {
                        role: item.id,
                      },
                      update: (
                        cache,
                        {
                          data: {
                            deleteProcessingUser: { success },
                          },
                        }
                      ) => {
                        if (success) {
                          updateQuery((prevData) => {
                            const newRoles = prevData.processingRoles.slice();
                            const index = _.findIndex(newRoles, {
                              id: item.id,
                            });
                            newRoles.splice(index, 1);
                            return {
                              ...prevData,
                              processingRoles: newRoles,
                            };
                          });
                        } else {
                          this.setState({
                            deleteButtonState: "error",
                          });
                        }
                      },
                    })
                    .catch(() => {
                      this.setState({
                        deleteButtonState: "error",
                      });
                    });
                }}
              >
                {"Удалить"}
              </ButtonComposed>
            </div>
            <div className={classnames(theme.accesses)}>
              <Labeled
                label={"Доступы для роли"}
                theme={{ value: theme.label }}
              >
                {item.accesses.map((access) => (
                  <ProcessingAccess key={access.id} item={access} />
                ))}
              </Labeled>
            </div>
          </div>
        )}
      </ProcessingRoleMutations>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingRole/ProcessingRole.js